import React from "react";

type PropsType = {
  className?: string;
  size?: number;
};

const FollowUps: React.FC<PropsType> = ({ size = 50, className = "" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      width={size}
      height={size}
      viewBox="0 0 50 50"
      fill="none"
    >
      <path
        d="M24.3126 14.3362C24.6436 13.8533 25.3564 13.8533 25.6874 14.3362L28.3592 18.2347C28.4675 18.3928 28.6271 18.5087 28.811 18.5629L33.3442 19.8993C33.9059 20.0648 34.1261 20.7427 33.7691 21.2068L30.887 24.9525C30.7702 25.1044 30.7092 25.292 30.7145 25.4836L30.8444 30.2079C30.8605 30.7932 30.2839 31.2122 29.7322 31.016L25.2792 29.4325C25.0986 29.3683 24.9014 29.3683 24.7208 29.4325L20.2678 31.016C19.7161 31.2122 19.1395 30.7932 19.1556 30.2079L19.2855 25.4836C19.2908 25.292 19.2298 25.1044 19.113 24.9525L16.2309 21.2068C15.8739 20.7427 16.0941 20.0648 16.6558 19.8993L21.189 18.5629C21.3729 18.5087 21.5325 18.3928 21.6408 18.2347L24.3126 14.3362Z"
        fill="#FFD440"
        stroke="#003125"
        stroke-width="3"
      />
      <path
        d="M4.16699 10.8333C4.16699 8.99239 5.65938 7.5 7.50033 7.5H42.5003C44.3413 7.5 45.8337 8.99238 45.8337 10.8333V35C45.8337 36.8409 44.3413 38.3333 42.5003 38.3333H33.6251C32.6472 38.3333 31.7187 38.7627 31.0853 39.5078L27.5401 43.6787C26.209 45.2447 23.7916 45.2447 22.4605 43.6787L18.9153 39.5078C18.282 38.7627 17.3534 38.3333 16.3755 38.3333H7.50032C5.65938 38.3333 4.16699 36.841 4.16699 35V10.8333Z"
        stroke="#003125"
        stroke-width="3"
      />
    </svg>
  );
};

export default FollowUps;
